import routeName from '../constant';
import { guideRoutes } from '@/utils/guideRoutes';

const routes = [
    {
        path: 'ntd-averaging-terms',
        name: routeName.NTD_AVERAGING_TERMS,
        component: () => import('@/views/aplCatl640and631/A9/landingPage/Index.vue'),
        meta: { auth: true, metaTitle: '新台幣貨幣帳戶定期定額投資金額轉換說明', leaveAlert: true, code: 'A9', unableBack: true },
    },
    {
        path: 'ntd-averaging',
        name: routeName.NTD_AVERAGING,
        component: () => import('@/views/aplCatl640and631/A9/ntdAveraging/Index.vue'),
        meta: { auth: true, metaTitle: '新台幣貨幣帳戶定期定額投資金額轉換', leaveAlert: true, code: 'A9', unableBack: true },
        beforeEnter: (to, from, next) => {
            const whiteList = [routeName.NTD_AVERAGING_TERMS, routeName.CONFIRM_DATA];
            const guideRoute = guideRoutes(from, whiteList, true);
            next(guideRoute);
        },
    }
];

export default routes;
